/**
 * Typing Indicator Component
 * 
 * Shows animated dots while Venchy is "typing" a response.
 */

import React from "react";
import styles from "../venchy.module.css";

interface ITypingIndicatorProps {
  isActive: boolean;
}

const TypingIndicator: React.FC<ITypingIndicatorProps> = ({ isActive }) => {
  if (!isActive) return null;
  
  return (
    <div className={`${styles.venchyTypingIndicator} ${isActive ? styles.active : ''}`}>
      <div className={styles.venchyMessageAvatar} style={{ 
        background: 'linear-gradient(135deg, #6B46C1, #8B5CF6)', 
        color: 'white',
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px'
      }}>
        🤖
      </div>
      <div className={styles.venchyTypingDots}>
        <div className={styles.venchyTypingDot}></div>
        <div className={styles.venchyTypingDot}></div>
        <div className={styles.venchyTypingDot}></div>
      </div>
    </div>
  );
};

export default TypingIndicator;
